import { GetAlgoliaEnvironment } from './EnvironmentUtils';

const GetAlgoliaPrefix = () => {
    const env = GetAlgoliaEnvironment();

    switch (env) {
        case 'dev': return 'dev_';
        case 'int': return 'dev_';
        case 'test': return 'test_';
        case 'uat': return 'uat_';
        case 'stage': return 'stage_';
        default: return 'prod_';
    }
};

// eslint-disable-next-line import/prefer-default-export
export const GetAlgoliaIndex = (indexName: string) => `${GetAlgoliaPrefix()}${indexName}`;
